export const generateRandomHexColor = () => `#${((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0')}`;

type ToQueryString = (params: { [name: string]: any }) => string;

export const toQueryString: ToQueryString = (params) => {
  return Object.entries(params)
    .filter(([, value]) => !!value)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
};

export const arrayIntersect = (firstArray: any[], secondArray: any[], matchingKey: string | undefined): any[] => {
  return firstArray.filter((e: any) => {
    const value = matchingKey ? e[matchingKey] : e;
    return secondArray.includes(value);
  });
};

export const convertMinutesToStringFormat = (minutes: number, showAm?: boolean, militaryTime?: boolean): string => {
  let hours = Math.floor(minutes / 60);
  const a = hours >= 12 ? 'pm' : 'am';

  if (!militaryTime) {
    if (hours >= 12) {
      hours -= 12;
    }

    if (hours === 0) {
      hours = 12;
    }
  }

  const hour = hours.toString(10).padStart(2, '0');
  const min = (minutes % 60).toString().padStart(2, '0');
  return `${hour}:${min} ${showAm ? a : ''}`;
};

export const numberWithCommas = (x: number) => {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

type DownloadBlobProps = {
  data: File;
  filename: string;
  type: string; // e.g 'application/pdf'
};

export const downloadBlob = ({ data, filename, type }: DownloadBlobProps): void => {
  const file = new Blob([data], { type });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(file);
  link.download = filename;
  link.click();
};

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
